import { useEffect, useRef } from "react";

export function useDocumentTitle(title: string, prevail_on_unmount: boolean = false) {
  const default_title = useRef(document.title);

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => () => {
    if (!prevail_on_unmount) {
      document.title = default_title.current;
    }
  }, []);
}
